import React, { useContext } from "react";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { FormControl } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import { Radio } from "@material-ui/core";
import { RadioGroup } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { FormContext } from "../../util/context";

const useStyles = makeStyles((theme) =>
  createStyles({
    smallRadioButton: {
      "& svg": {
        width: "1.5em",
        height: "1.5em",
      },
    },
  })
);

const Exercise = () => {
  const classes = useStyles();
  const [form, setForm] = useContext(FormContext);
  return (
    <>
      <Container maxWidth="sm">
        <Typography align="center" variant="h4">
          How frequently do you exercise?
        </Typography>
      </Container>
      <Box mt={5}>
        <Container maxWidth="md">
          <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
              <FormControl size="medium">
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={form.exerciseFrequency}
                  name="radio-buttons-group"
                  onChange={(event) => {
                    setForm({
                      ...form,
                      exerciseFrequency: event.target.value,
                      count: form.count + 1,
                    });
                  }}
                >
                  <FormControlLabel
                    value="0x"
                    control={<Radio color="primary" />}
                    label={
                      <Typography variant="h6">
                        Less than once a week
                      </Typography>
                    }
                    className={classes.smallRadioButton}
                  />
                  <FormControlLabel
                    value="1-2x per week"
                    control={<Radio color="primary" />}
                    label={<Typography variant="h6">Once a week</Typography>}
                    className={classes.smallRadioButton}
                  />
                  <FormControlLabel
                    value="Every other day"
                    control={<Radio color="primary" />}
                    label={
                      <Typography variant="h6">2-4 times a week</Typography>
                    }
                    className={classes.smallRadioButton}
                  />
                  <FormControlLabel
                    value="Every day"
                    control={<Radio color="primary" />}
                    label={
                      <Typography variant="h6">5+ times a week</Typography>
                    }
                    className={classes.smallRadioButton}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Exercise;
